/** Towns drivers plan trips between (approximate centres). */
export const PLACES: { name: string; lat: number; lng: number }[] = [
  { name: 'Kathmandu', lat: 27.7172, lng: 85.324 },
  { name: 'Lalitpur', lat: 27.6644, lng: 85.3188 },
  { name: 'Bhaktapur', lat: 27.671, lng: 85.4298 },
  { name: 'Dhulikhel', lat: 27.62, lng: 85.555 },
  { name: 'Pokhara', lat: 28.2096, lng: 83.9856 },
  { name: 'Bharatpur (Chitwan)', lat: 27.6833, lng: 84.4333 },
  { name: 'Mugling', lat: 27.854, lng: 84.556 },
  { name: 'Kurintar', lat: 27.872, lng: 84.605 },
  { name: 'Malekhu', lat: 27.82, lng: 84.84 },
  { name: 'Damauli', lat: 27.9714, lng: 84.265 },
  { name: 'Bandipur', lat: 27.9349, lng: 84.4087 },
  { name: 'Gorkha', lat: 28.0, lng: 84.6333 },
  { name: 'Besisahar', lat: 28.23, lng: 84.38 },
  { name: 'Hetauda', lat: 27.428, lng: 85.0322 },
  { name: 'Simara', lat: 27.16, lng: 84.98 },
  { name: 'Birgunj', lat: 27.0104, lng: 84.877 },
  { name: 'Bardibas', lat: 26.993, lng: 85.896 },
  { name: 'Janakpur', lat: 26.7288, lng: 85.9266 },
  { name: 'Itahari', lat: 26.6646, lng: 87.2718 },
  { name: 'Biratnagar', lat: 26.4525, lng: 87.2718 },
  { name: 'Dharan', lat: 26.8065, lng: 87.2846 },
  { name: 'Kawasoti', lat: 27.639, lng: 84.125 },
  { name: 'Butwal', lat: 27.7006, lng: 83.4483 },
  { name: 'Bhairahawa', lat: 27.5, lng: 83.45 },
  { name: 'Lumbini', lat: 27.4833, lng: 83.2833 },
  { name: 'Tansen', lat: 27.8667, lng: 83.55 },
  { name: 'Beni', lat: 28.35, lng: 83.5667 },
  { name: 'Lamahi', lat: 27.87, lng: 82.53 },
  { name: 'Ghorahi', lat: 28.0333, lng: 82.4833 },
  { name: 'Nepalgunj', lat: 28.05, lng: 81.6167 },
  { name: 'Birendranagar (Surkhet)', lat: 28.6, lng: 81.6333 },
  { name: 'Dhangadhi', lat: 28.6833, lng: 80.6 },
]
